<template>
  <svg
    id="mdi-toggle-switch-off"
    :class="customStyle"
    fill="#E5E7EB"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M7,15A3,3 0 0,1 4,12A3,3 0 0,1 7,9A3,3 0 0,1 10,12A3,3 0 0,1 7,15Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SwitchOffIcon',
  props: {
    customStyle: {
      type: String,
      default: 'size-12',
    },
  },
}
</script>
